import React, { useState } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import { authAPI } from "../services/api";
import { notify } from "../utils/notify";

function ResetPassword() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPwd, setShowPwd] = useState(false);
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!token) {
      notify.error("Reset link is invalid or missing a token.");
      return;
    }
    if (password.length < 8) {
      notify.warn("Password must be at least 8 characters");
      return;
    }
    if (password !== confirmPassword) {
      notify.warn("Passwords do not match");
      return;
    }
    setLoading(true);
    try {
      await authAPI.resetPassword(token, password);
      notify.success("Password reset successfully! Please sign in.");
      setDone(true);
      setTimeout(() => navigate("/"), 2000);
    } catch (err) {
      notify.error(err.message || "Reset link is invalid or has expired.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        background:
          "linear-gradient(135deg,#1e3a5f 0%,#1a5276 50%,#1e8449 100%)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 20,
      }}
    >
      <div style={{ width: "100%", maxWidth: 440 }}>
        <div
          style={{
            background: "#fff",
            borderRadius: 20,
            padding: "32px 32px 28px",
            boxShadow: "0 20px 60px rgba(0,0,0,0.25)",
          }}
        >
          <div className="text-center mb-3">
            <img className="mb-3" src="/assets/images/logo.png" width="180" alt="TSE" />
            <div style={{ color: "#000", fontWeight: 700, fontSize: "1rem" }}>
              TSE WORKSPACE
            </div>
          </div>

          {!token ? (
            <div className="text-center py-3">
              <i className="bi bi-exclamation-triangle" style={{ fontSize: 40, color: "#dc2626" }} />
              <p className="mt-3" style={{ fontSize: "0.9rem", color: "#374151" }}>
                This reset link is invalid or missing a token. Please request a
                new one from the login page.
              </p>
              <Link to="/" className="btn btn-light rounded-3 px-4 mt-2">Back to Login</Link>
            </div>
          ) : done ? (
            <div className="text-center py-3">
              <i className="bi bi-check-circle" style={{ fontSize: 40, color: "#16a34a" }} />
              <p className="mt-3" style={{ fontSize: "0.9rem", color: "#374151" }}>
                Your password has been updated. Redirecting you to login...
              </p>
            </div>
          ) : (
            <form onSubmit={handleSubmit}>
              <h5 style={{ fontWeight: 600, color: "#111827", marginBottom: 20, textAlign: "center" }}>
                Set a new password
              </h5>

              <div style={{ marginBottom: 16 }}>
                <label style={{ fontSize: "0.78rem", fontWeight: 700, color: "#374151", display: "block", marginBottom: 6 }}>
                  New Password
                </label>
                <div style={{ display: "flex", alignItems: "center", border: "1.5px solid #e5e7eb", borderRadius: 10, padding: "0 14px", gap: 8, background: "#f9fafb" }}>
                  <i className="bi bi-lock" style={{ color: "#9ca3af" }} />
                  <input
                    type={showPwd ? "text" : "password"}
                    placeholder="At least 8 characters"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    style={{ border: "none", outline: "none", background: "transparent", padding: "11px 0", fontSize: "0.88rem", flex: 1, color: "#111827" }}
                  />
                  <i
                    className={`bi ${showPwd ? "bi-eye-slash" : "bi-eye"}`}
                    style={{ color: "#9ca3af", cursor: "pointer" }}
                    onClick={() => setShowPwd((v) => !v)}
                  />
                </div>
              </div>

              <div style={{ marginBottom: 20 }}>
                <label style={{ fontSize: "0.78rem", fontWeight: 700, color: "#374151", display: "block", marginBottom: 6 }}>
                  Confirm New Password
                </label>
                <div style={{ display: "flex", alignItems: "center", border: "1.5px solid #e5e7eb", borderRadius: 10, padding: "0 14px", gap: 8, background: "#f9fafb" }}>
                  <i className="bi bi-lock-fill" style={{ color: "#9ca3af" }} />
                  <input
                    type={showPwd ? "text" : "password"}
                    placeholder="Re-enter new password"
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    style={{ border: "none", outline: "none", background: "transparent", padding: "11px 0", fontSize: "0.88rem", flex: 1, color: "#111827" }}
                  />
                </div>
              </div>

              <button
                type="submit"
                disabled={loading}
                style={{
                  display: "block",
                  width: "100%",
                  background: "linear-gradient(135deg,#1a5276,#1e8449)",
                  color: "#fff",
                  padding: "13px",
                  borderRadius: 12,
                  fontWeight: 700,
                  fontSize: "0.95rem",
                  border: "none",
                  cursor: loading ? "not-allowed" : "pointer",
                  opacity: loading ? 0.75 : 1,
                }}
              >
                {loading ? (
                  <span className="spinner-border spinner-border-sm me-2" />
                ) : (
                  <>
                    <i className="bi bi-check2-circle me-2" />
                    Update Password
                  </>
                )}
              </button>

              <div className="text-center mt-3">
                <Link to="/" style={{ fontSize: "0.8rem", color: "#1a5276", fontWeight: 600 }}>
                  Back to Login
                </Link>
              </div>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
export default ResetPassword;
